import { atom } from "jotai";

export const whiteLabelTenantAtom = atom<"resilio" | null>(null);
